// generated by genversion
export var version = '4.3.8';
//# sourceMappingURL=version.js.map